import { render, staticRenderFns } from "./secondChildCom.vue?vue&type=template&id=486e1658&scoped=true"
var script = {}
import style0 from "./secondChildCom.vue?vue&type=style&index=0&id=486e1658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486e1658",
  null
  
)

export default component.exports